import { type AiOfferAcceptRequestFEDTO, type AiOfferDTO } from 'ecosystem'
import { arrayFindAndUpdateItem } from 'shared-utils'
import { baseSplitApi, type BaseSplitApiExtendable } from '../../store-utils'

export const generateAcceptAiOfferEndpoint = <T extends BaseSplitApiExtendable>(rtkBaseApi: T) => {
  return rtkBaseApi.injectEndpoints({
    endpoints: (builder) => ({
      acceptAiOffer: builder.mutation<void, AiOfferAcceptRequestFEDTO>({
        query: ({ offerId }) => ({
          url: `ai-offers/accept-offer`,
          method: 'POST',
          body: {
            offerId
          }
        }),
        onQueryStarted: async ({ offerId, sessionId }, { queryFulfilled, dispatch }) => {
          try {
            dispatch(
              rtkBaseApi.util.updateQueryData(
                // @ts-expect-error -- name of endpoint
                'getAiOffers',
                { sessionId },
                (offers: AiOfferDTO[]) => {
                  if (Array.isArray(offers)) {
                    arrayFindAndUpdateItem({
                      arr: offers,
                      compare: (offer) => offer.id === offerId,
                      cb: (offer) => {
                        offer.accepted = true
                      }
                    })
                  }
                }
              )
            )

            await queryFulfilled
          } catch (_e) {
            /* empty */
          }
        }
      })
    }),
    overrideExisting: true
  })
}

export const acceptAiOfferEndpoint = generateAcceptAiOfferEndpoint(baseSplitApi)

export const { useAcceptAiOfferMutation } = acceptAiOfferEndpoint
